import { SET_JSON, CLEAR_JSON, SET_ORIGINAL_JSON_VAL } from './actionTypes'

export const setJson = jsonVal => dispatch => new Promise(resolve => {
	dispatch({
		type: SET_JSON,
		payload: {
			jsonVal,
		},
	})
	resolve()
})

export const setOriginalJson = jsonVal => dispatch => new Promise(resolve => {
	dispatch({
		type: SET_ORIGINAL_JSON_VAL,
		payload: {
			jsonVal,
		},
	})
	resolve()
})

export const clearJson = () => dispatch => new Promise(resolve => {
	dispatch({
		type: CLEAR_JSON,
		payload: null,
	})
	resolve()
})
